import type { ApiV1WalkWalkIdLocationPostRequest, WalkApi } from '../generated'
import { createAPISlice } from './createAPISlice'

export default function createSurveyWalkApis(walkApi: WalkApi) {
  return createAPISlice({
    addLocation: async (
      walkApiId: string,
      data: ApiV1WalkWalkIdLocationPostRequest,
    ) => {
      return await walkApi.apiV1WalkWalkIdLocationPost(walkApiId, data)
    },
    addLocations: async (
      walkApiId: string,
      data: ApiV1WalkWalkIdLocationPostRequest[],
    ) => {
      return await walkApi.apiV1WalkWalkIdLocationsPost(walkApiId, {
        locations: data,
      })
    },
    updateWalk: async (
      walkApiId: string,
      data: { endedAt?: Date; deviceSerialNumber?: string; distance: number },
    ) => {
      return await walkApi.apiV1WalkWalkIdPatch(walkApiId, {
        endedAt: data.endedAt?.toISOString(),
        deviceSerialNumber: data.deviceSerialNumber,
        distance: data.distance,
      })
    },
  })
}
